import React from 'react';
import { Box, Typography } from '@mui/material';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import ShareButton from '../ShareButton';
import { AddMenuButton, MuiCardBaseProps } from '../cards/MuiCard/MuiCardBase/MuiCardBase';
import { ShareModalItemTypeEnum } from '../../types/sharing';
import { Product } from '@klab-berlin/api-sdk/lib/types/responses/Product';
import { MindItem } from '@klab-berlin/api-sdk/lib/types/responses/MindItem';

const SummaryTitle: React.FC<{
  showShareButton?: boolean;
  shareType?: ShareModalItemTypeEnum;
  itemId: string;
  itemData: Partial<Product> | Partial<MindItem>;
  type: MuiCardBaseProps['contentType']
  title: string;
}> = ({ showShareButton, shareType, itemId, itemData, title, type }) => (
  <Box
    sx={{
      color: palette.text.primary,
      padding: `${spaces.md} 0px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}
    data-testid='summary-title'
  >
    <Typography variant='h5'>{title}</Typography>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: spaces.xs,
      }}
    >
      {showShareButton && shareType && (
        <ShareButton type={shareType} itemId={itemId} size='large' />
      )}
      <AddMenuButton
        isPinned={!!itemData.isPinned}
        id={itemId}
        itemData={itemData}
        type={type}
        buttonSx={{
          position: 'relative',
          top: 'unset',
          right: 0,
        }}
      />
    </Box>
  </Box>
);

export default SummaryTitle;
